import { useState, useEffect } from 'react';
import axiosInstance from 'utils/axiosInstance';
import axios from 'axios';
import { GET } from 'utils/constants';
import useEventTrace from 'utils/CommonRequestConfig';
import useCampignEventTrace from 'utils/CommonRequestConfigForCampign';
/**This custom hooks is used to onPageLoad calling Api using only GET method  */
const useAxiosFetch = ({ endPoint, method = GET, requestConfig = {} }) => {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {getDefaultReqConfig} = useEventTrace();
  const {getDefaultCampignReqConfig} = useCampignEventTrace();
  useEffect(() => {
    let isMounted = true;
    const source = axios.CancelToken.source();
    const fetchData = async (endPoint, requestConfig) => {
      try {
        setLoading(true);
        let response="";
        const defaultReqConfig = getDefaultReqConfig();
        const defaultCampignReqConfig = getDefaultCampignReqConfig();

        if (method.toLowerCase()==='get') {
          response = await axiosInstance[method.toLowerCase()](endPoint, {headers:{
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
           }}
          );
        }
        else if(method.toLowerCase()==='delete'){
          response = await axiosInstance[method.toLowerCase()](endPoint,{
            headers: {
              "X-Data-Token": defaultReqConfig,
              "X-cmpgn-tkn" : defaultCampignReqConfig
            },
            ...requestConfig,
            cancelToken: source.token,
           });
        }
        else{
          response = await axiosInstance[method.toLowerCase()](endPoint, {
            ...requestConfig,
            cancelToken: source.token,
           },{
            headers: {
              "X-Data-Token": defaultReqConfig,
              "X-cmpgn-tkn" : defaultCampignReqConfig
            }});
        }
        if (isMounted) {
          setResponse(response.data);
          setError(null);
        }
      } catch (err) {
        //console.log("error",err)
        if (isMounted) {
          setError(err.message);
          setResponse([]);
        }
      } finally {
        isMounted && setLoading(false);
      }
    };
    fetchData(endPoint, requestConfig);
    const cleanUp = () => {
      isMounted = false;
      source.cancel();
    };

    return cleanUp;
  }, []);

  return [response, error, loading];
};

export default useAxiosFetch;
